export const PAYMENT_LINK_EMAIL_TEMPLATE_DEFAULT = `Hello,
Please find the payment link for invoice {{invoice_number}} below.

{{payment_link}}

Let me know if you have any questions.

Best regards,
{{organization_name}}
{{billing_email}}
{{billing_phone}}`;
